export default {
	a: ["1:-xxx-",
			"3:x---x",
			"1:xxxxx",
			"2:x---x"],
	b: ["1:xxxx",
			"2:x---x", 
			 "1:xxxx",
			"2:x---x",
			 "1:xxxx"],
	c: ["1:-xxx",
			"1:x---x",
			 "3:x",
			 "1:x---x",
		  "1:-xxx"],
	d: ["1:xxxx",
			"5:x---x",
			"1:xxxx"],
	e: ["1:xxxxx",
		"2:x",
		"1:xxxx",
		"2:x",
		"1:xxxxx"],
	f: ["1:xxxxx",
		  "2:x",
		  "1:xxxx",
		  "2:x",
			"1:x"],
	g: ["1:-xxx",
			"1:x---x",
			 "2:x",
		  "1:x-xxx",
			"1:x---x",
			"1:-xxx-"],
	h: ["3:x---x",
			"1:xxxxx",
			"3:x---x"],	
	i: ["1:xxx",
			"5:-x",
			"1:xxx"],
	j: ["4:----x",
		  "2:x---x",
		  "1:-xxx"],
	k: ["1:x---x",
		  "1:x--x",
			"1:x-x",
			"1:xx",
			"1:x-x",
			"1:x--x",
		  "1:x---x"],
	l: ["6:x",
			"1:xxxxx"],
	m: ["1:x---x",
			"1:xx-xx",
			"2:x-x-x",
			"3:x---x"],
	n: ["2:x---x",
			"1:xx--x",
			"1:x-x-x",
			"1:x--xx",
			"2:x---x"],
	o: ["1:-xxx",
			"5:x---x",
		  "1:-xxx"],
	p: ["1:xxxx",
			"3:x---x",
			"1:xxxx",
			"2:x"],
	q: ["1:-xxx",
			"4:x---x",
		  "1:-xxx",
		  "1:----x"],
	r: ["1:xxxx",
			"3:x---x",
			"1:xxxx",
			"2:x---x"],
	s: ["1:-xxx-",
			"1:x---x",
			"1:x",
			 "1:-xxx-",
			"1:----x",
			"1:x---x",
			"1:-xxx"],
	t: ["1:xxxxx",
			"6:--x"],
	u: ["6:x---x",
		  "1:-xxx"],
	v: ["5:x---x",
		  "1:-x-x",
			"1:--x"],
	w: ["3:x---x",
			"2:x-x-x",			 
			"1:xx-xx",			 
		  "1:x---x"],
	x: ["2:x---x",
			"1:-x-x-",
			"1:--x",
			"1:-x-x",
			"2:x---x"],
	y: ["3:x---x",
			"1:-x-x",
			"3:--x"],
	z: ["1:xxxxx",
			"1:----x",
			"1:---x",
			"1:--x",
			 "1:-x",
			"1:x",
			"1:xxxxx"],
	1: ["1:-x",
			"1:xx",
			"5:-x"],
	2: ["1:xxxxx",
		  "2:----x",
		  "1:xxxxx",
		  "2:x",
			"1:xxxxx"],
	3: ["1:xxxxx",
		  "2:----x",
		  "1:xxxxx",
		  "2:----x",
			"1:xxxxx"],
	4: ["3:x---x",
		  "1:xxxxx",
		  "3:----x"],
	5: ["1:xxxxx",
		  "2:x",
		  "1:xxxxx",
		  "2:----x",
			"1:xxxxx"],
	6: ["1:xxxxx",
		  "2:x",
		  "1:xxxxx",
		  "2:x---x",
			"1:xxxxx"],
	7: ["1:xxxxx",
		  "2:----x",
		  "1:---x",
		  "3:--x"],
	8: ["1:xxxxx",
		  "2:x---x",
		  "1:xxxxx",
		  "2:x---x",
			"1:xxxxx"],
	9: ["1:xxxxx",
		  "2:x---x",
			"1:xxxxx",
			"2:----x",
			"1:xxxxx"],
	0: ["1:xxxxx",
		  "5:x---x",
			"1:xxxxx"],
	"!": ["5:x",
				"1:-",
				"1:x"],
	":": ["1:-",
				"1:x",
				"3:-",
				"1:x"],
	"(": ["1:-x",
			"5:x",
		  "1:-x"],
	")": ["1:x",
			"5:-x",
		  "1:x"],
	"-": ["3:-",
				"1:xxxx"],
	"?": ["1:-xxx",
			 "1:x---x",
			  "1:----x",
			  "1:---x",
		   "1:--x",
			 "1:-",
			 "1:--x"],
	//.@#%&*$"' simle
	 " ": ["1:-"],
	 ".": ["6:-",
				 "1:x"],
	  //heart
	 "{": ["1:-",
				 "1:-xx--xx-",
				 "2:xxxxxxxx",
				 "1:-xxxxxx",
				 "1:--xxxx",
				 "1:---xx"],
	//smile
	 "}": ["1:-xxxxx",
			   "1:x-----x",
				 "1:x-x-x-x",
			   "1:x-----x",
				 "1:x-xxx-x",
				 "1:x-----x",
				 "1:-xxxxx"],
	"@": ["1:-xxx",
				"1:x---x",
				"1:x-xxx",
				"1:x-x-x",
				"1:x-xxx",
				"1:x",
			"1:-xxxx"],
	"#": ["1:-",
				"1:-x-x",
				"1:xxxxx",
			  "1:-x-x",
				"1:xxxxx",
				"1:-x-x",
			  "1:-"],
	"+": ["1:-",
			  "2:--x",
			  "1:xxxxx",
			  "2:--x",
		"1:-"],
	"&": ["1:-xx",
			  "1:x--x",
			   "1:-xx",
			"1:x-x",
			  "1:x--x-x",
			  "1:x---x",
			  "1:-xxx-x"],
}